module.exports = __webpack_public_path__ + "22ec30c53513569dcee63f833b9d794c.png";